import { useState } from "react";
import type { ChartConfig } from "../types";

const LOCAL_STORAGE_KEY = "chart:settings";

// Define a default configuration in case nothing is in localStorage
const DEFAULT_CHART_CONFIG: Partial<ChartConfig> = {
  theme: "light",
  tooltip: { enabled: true },
  grid: { showX: false, showY: true },
  animated: true,
  backgroundPattern: false,
  // Sensible defaults for axes if none are provided
  axes: {
    x: { position: "bottom" },
    y: { position: "left" },
  },
  series: [], // Default to no series, must be provided by user
  xKey: "", // Must be provided by user
  yKeys: [], // Empty array as default
};

export function useChartSettings(): Partial<ChartConfig> {
  const [settings, setSettings] = useState<Partial<ChartConfig>>(() => {
    try {
      const savedSettings = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (savedSettings) {
        // Merge saved settings with defaults to ensure all keys are present
        return { ...DEFAULT_CHART_CONFIG, ...JSON.parse(savedSettings) };
      }
    } catch (error) {
      console.error("Error reading chart settings from localStorage:", error);
      // Fallback to default if error occurs (e.g., localStorage unavailable or corrupted data)
    }
    return DEFAULT_CHART_CONFIG;
  });

  // Optional: If you want the hook to update when localStorage changes externally,
  // you could add an effect with a storage event listener.

  // Optional: Function to save/update settings
  // const saveSettings = (newSettings: Partial<ChartConfig>) => {
  //   try {
  //     const mergedSettings = { ...settings, ...newSettings };
  //     localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(mergedSettings));
  //     setSettings(mergedSettings);
  //   } catch (error) {
  //     console.error('Error saving chart settings to localStorage:', error);
  //   }
  // };

  // Return only the settings for now, as per the spec
  // You might want to return saveSettings as well in a real application
  return settings;
}
